import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GuestFeedbackBatchDetailsFragment = { __typename?: 'GuestFeedbackUploadBatch', id: string, revision: number, status: Types.GuestFeedbackUploadBatchStatus, createdAt: string, files: Array<{ __typename?: 'OrgGuestFeedbackCsvUpload', id: string, fileName?: string | null, status: Types.GuestFeedbackCsvUploadStatus, error?: string | null, importedReviewCount: number, fileUrl: string, feedbackTextColumn: string, feedbackDateColumn: string, ratingColumn: string, ratingColumnMin?: number | null, ratingColumnMax?: number | null, locationColumn: string, feedbackSource?: string | null, locations: Array<{ __typename?: 'OrgGuestFeedbackCsvUploadLocation', id: string, locationName: string, location: { __typename?: 'Location', id: number } }> }>, analysisRun?: { __typename?: 'GuestFeedbackAnalysisRun', id: string, status: Types.GuestFeedbackAnalysisRunStatus, startedAt: string, completedAt?: string | null, error?: string | null } | null };

export type GuestFeedbackUploadBatchQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type GuestFeedbackUploadBatchQuery = { __typename?: 'Query', GuestFeedbackUploadBatch?: { __typename?: 'GuestFeedbackUploadBatch', id: string, revision: number, status: Types.GuestFeedbackUploadBatchStatus, createdAt: string, files: Array<{ __typename?: 'OrgGuestFeedbackCsvUpload', id: string, fileName?: string | null, status: Types.GuestFeedbackCsvUploadStatus, error?: string | null, importedReviewCount: number, fileUrl: string, feedbackTextColumn: string, feedbackDateColumn: string, ratingColumn: string, ratingColumnMin?: number | null, ratingColumnMax?: number | null, locationColumn: string, feedbackSource?: string | null, locations: Array<{ __typename?: 'OrgGuestFeedbackCsvUploadLocation', id: string, locationName: string, location: { __typename?: 'Location', id: number } }> }>, analysisRun?: { __typename?: 'GuestFeedbackAnalysisRun', id: string, status: Types.GuestFeedbackAnalysisRunStatus, startedAt: string, completedAt?: string | null, error?: string | null } | null } | null };

export type GuestFeedbackUploadAnalysisStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GuestFeedbackUploadAnalysisStatusQuery = { __typename?: 'Query', GuestFeedbackUploadAnalysisStatus: { __typename?: 'GuestFeedbackUploadAnalysisStatus', waitingBatchCount: number, activeRun?: { __typename?: 'GuestFeedbackAnalysisRun', id: string, status: Types.GuestFeedbackAnalysisRunStatus, startedAt: string } | null } };

export type PreviewGuestFeedbackUploadBatchMutationVariables = Types.Exact<{
  files: Array<Types.GuestFeedbackBatchFileInput> | Types.GuestFeedbackBatchFileInput;
}>;


export type PreviewGuestFeedbackUploadBatchMutation = { __typename?: 'Mutation', previewGuestFeedbackUploadBatch: { __typename?: 'GuestFeedbackUploadPreviewResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, files: Array<{ __typename?: 'GuestFeedbackUploadFilePreview', fileName: string, reviewCount: number, duplicateRowCount: number, invalidRowCount: number, locationCount: number, earliestReviewDate?: string | null, latestReviewDate?: string | null, oldReviewCount: number, error?: string | null }> } };

export type SubmitGuestFeedbackUploadBatchMutationVariables = Types.Exact<{
  submissionId: Types.Scalars['UUID']['input'];
  files: Array<Types.GuestFeedbackBatchFileInput> | Types.GuestFeedbackBatchFileInput;
}>;


export type SubmitGuestFeedbackUploadBatchMutation = { __typename?: 'Mutation', submitGuestFeedbackUploadBatch: { __typename?: 'GuestFeedbackUploadBatchMutationResult', success: boolean, analysisRunning: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, batch?: { __typename?: 'GuestFeedbackUploadBatch', id: string, revision: number, status: Types.GuestFeedbackUploadBatchStatus, createdAt: string, files: Array<{ __typename?: 'OrgGuestFeedbackCsvUpload', id: string, fileName?: string | null, status: Types.GuestFeedbackCsvUploadStatus, error?: string | null, importedReviewCount: number, fileUrl: string, feedbackTextColumn: string, feedbackDateColumn: string, ratingColumn: string, ratingColumnMin?: number | null, ratingColumnMax?: number | null, locationColumn: string, feedbackSource?: string | null, locations: Array<{ __typename?: 'OrgGuestFeedbackCsvUploadLocation', id: string, locationName: string, location: { __typename?: 'Location', id: number } }> }>, analysisRun?: { __typename?: 'GuestFeedbackAnalysisRun', id: string, status: Types.GuestFeedbackAnalysisRunStatus, startedAt: string, completedAt?: string | null, error?: string | null } | null } | null } };

export type RetryGuestFeedbackUploadBatchMutationVariables = Types.Exact<{
  batchId: Types.Scalars['UUID']['input'];
  expectedRevision: Types.Scalars['Int']['input'];
  files: Array<Types.GuestFeedbackBatchFileInput> | Types.GuestFeedbackBatchFileInput;
}>;


export type RetryGuestFeedbackUploadBatchMutation = { __typename?: 'Mutation', retryGuestFeedbackUploadBatch: { __typename?: 'GuestFeedbackUploadBatchMutationResult', success: boolean, analysisRunning: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, batch?: { __typename?: 'GuestFeedbackUploadBatch', id: string, revision: number, status: Types.GuestFeedbackUploadBatchStatus, createdAt: string, files: Array<{ __typename?: 'OrgGuestFeedbackCsvUpload', id: string, fileName?: string | null, status: Types.GuestFeedbackCsvUploadStatus, error?: string | null, importedReviewCount: number, fileUrl: string, feedbackTextColumn: string, feedbackDateColumn: string, ratingColumn: string, ratingColumnMin?: number | null, ratingColumnMax?: number | null, locationColumn: string, feedbackSource?: string | null, locations: Array<{ __typename?: 'OrgGuestFeedbackCsvUploadLocation', id: string, locationName: string, location: { __typename?: 'Location', id: number } }> }>, analysisRun?: { __typename?: 'GuestFeedbackAnalysisRun', id: string, status: Types.GuestFeedbackAnalysisRunStatus, startedAt: string, completedAt?: string | null, error?: string | null } | null } | null } };

export const GuestFeedbackBatchDetailsFragmentDoc = gql`
    fragment GuestFeedbackBatchDetails on GuestFeedbackUploadBatch {
  id
  revision
  status
  createdAt
  files {
    id
    fileName
    status
    error
    importedReviewCount
    fileUrl
    feedbackTextColumn
    feedbackDateColumn
    ratingColumn
    ratingColumnMin
    ratingColumnMax
    locationColumn
    feedbackSource
    locations {
      id
      locationName
      location {
        id
      }
    }
  }
  analysisRun {
    id
    status
    startedAt
    completedAt
    error
  }
}
    `;
export const GuestFeedbackUploadBatchDocument = gql`
    query GuestFeedbackUploadBatch($id: UUID!) {
  GuestFeedbackUploadBatch(id: $id) {
    ...GuestFeedbackBatchDetails
  }
}
    ${GuestFeedbackBatchDetailsFragmentDoc}`;

/**
 * __useGuestFeedbackUploadBatchQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackUploadBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackUploadBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackUploadBatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGuestFeedbackUploadBatchQuery(baseOptions: Apollo.QueryHookOptions<GuestFeedbackUploadBatchQuery, GuestFeedbackUploadBatchQueryVariables> & ({ variables: GuestFeedbackUploadBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackUploadBatchQuery, GuestFeedbackUploadBatchQueryVariables>(GuestFeedbackUploadBatchDocument, options);
      }
export function useGuestFeedbackUploadBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackUploadBatchQuery, GuestFeedbackUploadBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackUploadBatchQuery, GuestFeedbackUploadBatchQueryVariables>(GuestFeedbackUploadBatchDocument, options);
        }
export type GuestFeedbackUploadBatchQueryHookResult = ReturnType<typeof useGuestFeedbackUploadBatchQuery>;
export type GuestFeedbackUploadBatchLazyQueryHookResult = ReturnType<typeof useGuestFeedbackUploadBatchLazyQuery>;
export type GuestFeedbackUploadBatchQueryResult = Apollo.QueryResult<GuestFeedbackUploadBatchQuery, GuestFeedbackUploadBatchQueryVariables>;
export const GuestFeedbackUploadAnalysisStatusDocument = gql`
    query GuestFeedbackUploadAnalysisStatus {
  GuestFeedbackUploadAnalysisStatus {
    activeRun {
      id
      status
      startedAt
    }
    waitingBatchCount
  }
}
    `;

/**
 * __useGuestFeedbackUploadAnalysisStatusQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackUploadAnalysisStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackUploadAnalysisStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackUploadAnalysisStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestFeedbackUploadAnalysisStatusQuery(baseOptions?: Apollo.QueryHookOptions<GuestFeedbackUploadAnalysisStatusQuery, GuestFeedbackUploadAnalysisStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackUploadAnalysisStatusQuery, GuestFeedbackUploadAnalysisStatusQueryVariables>(GuestFeedbackUploadAnalysisStatusDocument, options);
      }
export function useGuestFeedbackUploadAnalysisStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackUploadAnalysisStatusQuery, GuestFeedbackUploadAnalysisStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackUploadAnalysisStatusQuery, GuestFeedbackUploadAnalysisStatusQueryVariables>(GuestFeedbackUploadAnalysisStatusDocument, options);
        }
export type GuestFeedbackUploadAnalysisStatusQueryHookResult = ReturnType<typeof useGuestFeedbackUploadAnalysisStatusQuery>;
export type GuestFeedbackUploadAnalysisStatusLazyQueryHookResult = ReturnType<typeof useGuestFeedbackUploadAnalysisStatusLazyQuery>;
export type GuestFeedbackUploadAnalysisStatusQueryResult = Apollo.QueryResult<GuestFeedbackUploadAnalysisStatusQuery, GuestFeedbackUploadAnalysisStatusQueryVariables>;
export const PreviewGuestFeedbackUploadBatchDocument = gql`
    mutation PreviewGuestFeedbackUploadBatch($files: [GuestFeedbackBatchFileInput!]!) {
  previewGuestFeedbackUploadBatch(files: $files) {
    success
    error {
      code
      message
    }
    files {
      fileName
      reviewCount
      duplicateRowCount
      invalidRowCount
      locationCount
      earliestReviewDate
      latestReviewDate
      oldReviewCount
      error
    }
  }
}
    `;
export type PreviewGuestFeedbackUploadBatchMutationFn = Apollo.MutationFunction<PreviewGuestFeedbackUploadBatchMutation, PreviewGuestFeedbackUploadBatchMutationVariables>;

/**
 * __usePreviewGuestFeedbackUploadBatchMutation__
 *
 * To run a mutation, you first call `usePreviewGuestFeedbackUploadBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewGuestFeedbackUploadBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewGuestFeedbackUploadBatchMutation, { data, loading, error }] = usePreviewGuestFeedbackUploadBatchMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function usePreviewGuestFeedbackUploadBatchMutation(baseOptions?: Apollo.MutationHookOptions<PreviewGuestFeedbackUploadBatchMutation, PreviewGuestFeedbackUploadBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewGuestFeedbackUploadBatchMutation, PreviewGuestFeedbackUploadBatchMutationVariables>(PreviewGuestFeedbackUploadBatchDocument, options);
      }
export type PreviewGuestFeedbackUploadBatchMutationHookResult = ReturnType<typeof usePreviewGuestFeedbackUploadBatchMutation>;
export type PreviewGuestFeedbackUploadBatchMutationResult = Apollo.MutationResult<PreviewGuestFeedbackUploadBatchMutation>;
export type PreviewGuestFeedbackUploadBatchMutationOptions = Apollo.BaseMutationOptions<PreviewGuestFeedbackUploadBatchMutation, PreviewGuestFeedbackUploadBatchMutationVariables>;
export const SubmitGuestFeedbackUploadBatchDocument = gql`
    mutation SubmitGuestFeedbackUploadBatch($submissionId: UUID!, $files: [GuestFeedbackBatchFileInput!]!) {
  submitGuestFeedbackUploadBatch(submissionId: $submissionId, files: $files) {
    success
    error {
      code
      message
    }
    analysisRunning
    batch {
      ...GuestFeedbackBatchDetails
    }
  }
}
    ${GuestFeedbackBatchDetailsFragmentDoc}`;
export type SubmitGuestFeedbackUploadBatchMutationFn = Apollo.MutationFunction<SubmitGuestFeedbackUploadBatchMutation, SubmitGuestFeedbackUploadBatchMutationVariables>;

/**
 * __useSubmitGuestFeedbackUploadBatchMutation__
 *
 * To run a mutation, you first call `useSubmitGuestFeedbackUploadBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGuestFeedbackUploadBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGuestFeedbackUploadBatchMutation, { data, loading, error }] = useSubmitGuestFeedbackUploadBatchMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSubmitGuestFeedbackUploadBatchMutation(baseOptions?: Apollo.MutationHookOptions<SubmitGuestFeedbackUploadBatchMutation, SubmitGuestFeedbackUploadBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitGuestFeedbackUploadBatchMutation, SubmitGuestFeedbackUploadBatchMutationVariables>(SubmitGuestFeedbackUploadBatchDocument, options);
      }
export type SubmitGuestFeedbackUploadBatchMutationHookResult = ReturnType<typeof useSubmitGuestFeedbackUploadBatchMutation>;
export type SubmitGuestFeedbackUploadBatchMutationResult = Apollo.MutationResult<SubmitGuestFeedbackUploadBatchMutation>;
export type SubmitGuestFeedbackUploadBatchMutationOptions = Apollo.BaseMutationOptions<SubmitGuestFeedbackUploadBatchMutation, SubmitGuestFeedbackUploadBatchMutationVariables>;
export const RetryGuestFeedbackUploadBatchDocument = gql`
    mutation RetryGuestFeedbackUploadBatch($batchId: UUID!, $expectedRevision: Int!, $files: [GuestFeedbackBatchFileInput!]!) {
  retryGuestFeedbackUploadBatch(
    batchId: $batchId
    expectedRevision: $expectedRevision
    files: $files
  ) {
    success
    error {
      code
      message
    }
    analysisRunning
    batch {
      ...GuestFeedbackBatchDetails
    }
  }
}
    ${GuestFeedbackBatchDetailsFragmentDoc}`;
export type RetryGuestFeedbackUploadBatchMutationFn = Apollo.MutationFunction<RetryGuestFeedbackUploadBatchMutation, RetryGuestFeedbackUploadBatchMutationVariables>;

/**
 * __useRetryGuestFeedbackUploadBatchMutation__
 *
 * To run a mutation, you first call `useRetryGuestFeedbackUploadBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryGuestFeedbackUploadBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryGuestFeedbackUploadBatchMutation, { data, loading, error }] = useRetryGuestFeedbackUploadBatchMutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *      expectedRevision: // value for 'expectedRevision'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useRetryGuestFeedbackUploadBatchMutation(baseOptions?: Apollo.MutationHookOptions<RetryGuestFeedbackUploadBatchMutation, RetryGuestFeedbackUploadBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryGuestFeedbackUploadBatchMutation, RetryGuestFeedbackUploadBatchMutationVariables>(RetryGuestFeedbackUploadBatchDocument, options);
      }
export type RetryGuestFeedbackUploadBatchMutationHookResult = ReturnType<typeof useRetryGuestFeedbackUploadBatchMutation>;
export type RetryGuestFeedbackUploadBatchMutationResult = Apollo.MutationResult<RetryGuestFeedbackUploadBatchMutation>;
export type RetryGuestFeedbackUploadBatchMutationOptions = Apollo.BaseMutationOptions<RetryGuestFeedbackUploadBatchMutation, RetryGuestFeedbackUploadBatchMutationVariables>;